import React from "react";
import { Icon } from "@iconify/react";

const DeleteDepartment = ({
    show = false,
    title = "Delete Department",
    message = "Are you sure you want to delete this department? This action cannot be undone.",
    icon = "mdi:delete-alert",
    confirmLabel = "Delete",
    cancelLabel = "Cancel",
    onConfirm,
    onCancel,
    loading = false,
    loadingMessage = "Deleting department...",
}) => {
    if (!show) return null;

    return (
        <div className="prompt-overlay">
            <div className="prompt-box">
                {loading ? (
                    // 🔵 Spinner view while deleting
                    <div
                        className="d-flex flex-column justify-content-center align-items-center"
                        style={{ height: "150px", gap: "1rem" }}
                    >
                        <div
                            className="spinner-border text-danger"
                            role="status"
                            style={{ width: "4rem", height: "4rem" }}
                        >
                            <span className="visually-hidden">Deleting...</span>
                        </div>
                        <p className="fs-5 text-danger">{loadingMessage}</p>
                    </div>
                ) : (
                    <>
                        {/* Icon */}
                        <div className="d-flex justify-content-center align-items-center mb-2">
                            <div
                                className="Loading-icon d-flex justify-content-center align-items-center"
                                style={{
                                    width: "50px",
                                    height: "50px",
                                    borderRadius: "50%",
                                    background: "#FFE5E5",
                                }}
                            >
                                <Icon icon={icon} className="fs-3 text-danger" />
                            </div>
                        </div>

                        {/* Title and message */}
                        <h3 className="prompt-title text-danger">{title}</h3>
                        <p className="text-muted">{message}</p>

                        {/* Buttons */}
                        <div className="prompt-actions mt-3 d-flex justify-content-center gap-3">
                            <button onClick={onCancel} className="cancel-button btn btn-outline-secondary px-4">
                                {cancelLabel}
                            </button>
                            <button onClick={onConfirm} className="confirm-button  px-4">
                                {confirmLabel}
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default DeleteDepartment;
